export const doCapitalizeStart = (
  sentence: string | undefined
): string | null => {
  return sentence
    ? sentence.slice(0, 1).toLocaleUpperCase() + sentence.slice(1)
    : null
}
